import "./Soporte.module.css";
import Header from "@/reusable_sections/Header";
import ConnectCulturesHero from "./sections/ConnectCulturesHero";
import DetailedServiceList from "./sections/DetailedServiceList";
import ComoPedir from "./sections/ComoPedir";
import ConnectWithUs from "./sections/ConnectWithUs";
import ArchitecturalPrecision from "./sections/ArchitecturalPrecision";
import Footer from "@/reusable_sections/Footer";
export default function SoportePage() {
  return <div>
      <Header />
      <ComoPedir />
      <ConnectCulturesHero />
      <ConnectWithUs />
      <DetailedServiceList />
      <ArchitecturalPrecision />
      <Footer />
    </div>;
}